import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";

// ─── Protección anti Self-XSS (igual que Facebook) ──────────────────────────
if (process.env.NODE_ENV === 'production') {
    console.clear();

    const stopStyle   = 'font-size:40px;font-weight:bold;color:#ef4444;';
    const warnStyle   = 'font-size:15px;color:#f97316;font-weight:600;';
    const normalStyle = 'font-size:13px;color:#94a3b8;';

    console.log('%c⛔ STOP', stopStyle);
    console.log(
        '%cEsta es una función del navegador dirigida a desarrolladores.\n' +
        'Si alguien te indicó copiar y pegar algo aquí para obtener acceso\n' +
        'a una cuenta o para "añadir funciones", es un engaño.\n' +
        'Ejecutar código en esta consola puede comprometer tu cuenta.',
        warnStyle
    );
    console.log('%c— Equipo de seguridad Fenine', normalStyle);

    const noop = () => {};
    console.log  = noop;
    console.warn = noop;
    console.info = noop;
}

// ─── Deshabilitar click derecho en el sitio público ─────────────────────────
if (process.env.NODE_ENV === 'production') {
    document.addEventListener('contextmenu', (e) => e.preventDefault());
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
